import produce from 'immer';

// TYPES
import { ReducerAction } from 'store/modules/types';
import { Types, EnviaRespostasAtendimento } from './types';

export const INITIAL_STATE: EnviaRespostasAtendimento = {
	status: 0,
	data: null,
	form: null,
};

export default function modulos(
	state = INITIAL_STATE,
	action: ReducerAction,
): EnviaRespostasAtendimento {
	return produce(state, draft => {
		switch (action.type) {
			case Types.ENVIA_RESPOSTAS_ATENDIMENTO_REQUEST: {
				draft.form = action.payload;
				break;
			}
			case Types.ENVIA_RESPOSTAS_ATENDIMENTO_SUCCESS: {
				draft.status = action.payload.status;
				draft.data = action.payload.data;
				break;
			}
			case Types.ENVIA_RESPOSTAS_ATENDIMENTO_FAILURE: {
				draft.status = 400;
				draft.data = action.payload;
				break;
			}
			case Types.ENVIA_RESPOSTAS_ATENDIMENTO_CLEAR: {
				draft.status = INITIAL_STATE.status;
				draft.data = INITIAL_STATE.data;
				draft.form = INITIAL_STATE.form;
				break;
			}

			default:
		}
		return draft;
	});
}
